import ListItemIcon from '@mui/material/ListItemIcon'
import withStyles from '@mui/styles/withStyles'

const CustomListItemIcon = withStyles((theme) => ({
  root: {
    minWidth: 'auto',
    marginRight: theme.spacing(2),
  },
}))(ListItemIcon)

export default CustomListItemIcon
